// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"4":"b3520697d44fd342","72":"2e484bc30227bdc1","85":"992d1e5fc3feebc7","181":"4868de12d9788a7f","294":"36aa92a7f11b3ca8","578":"3468279831dab557","599":"e554270bfdee78d7","623":"e32a050446c6ae97","822":"5852758fc95179cc"}[chunkId] + ".js";
};